export default "__VITE_ASSET__CzFDQGv0__"